module.exports = __webpack_public_path__ + "img/tenebristic_wonderland.f1d62dd2.jpg";